import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  Tooltip,
  TextField,
  IconButton,
  InputAdornment,
  TextFieldProps,
  Button,
} from '@mui/material'
import Iconify from './Iconify'
import useResponsive from '@/hooks/useResponsive'

type Props = {
  shareInputValue: string
  inputProps?: TextFieldProps
  onShareInputValueChange?: (value: string) => void
}

export default function CopyClipboard({
  shareInputValue: value,
  inputProps,
  onShareInputValueChange,
}: Props) {
  const isMobile = useResponsive('down', 'sm')
  const { enqueueSnackbar } = useSnackbar()
  const [state, setState] = useState({
    value,
    copied: false,
  })

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newVal = event.target.value
    setState({ value: newVal, copied: false })
    if (onShareInputValueChange) {
      onShareInputValueChange(newVal)
    }
  }

  const onCopy = () => {
    setState({ ...state, copied: true })
    if (state.value) {
      enqueueSnackbar('Copied!')
    }
  }

  return (
    <>
      <TextField
        fullWidth
        multiline
        maxRows={15}
        value={state.value}
        onChange={handleChange}
        InputProps={{
          endAdornment: isMobile ? null : (
            <InputAdornment position="end">
              <CopyToClipboard text={state.value} onCopy={onCopy}>
                <Tooltip title="Copy">
                  <IconButton>
                    <Iconify icon={'eva:copy-fill'} width={24} height={24} />
                  </IconButton>
                </Tooltip>
              </CopyToClipboard>
            </InputAdornment>
          ),
        }}
        {...inputProps}
      />
      {isMobile && (
        <CopyToClipboard text={state.value} onCopy={onCopy}>
          <Button fullWidth variant="outlined" sx={{ mt: 1 }}>
            Copy to Clipboard
          </Button>
        </CopyToClipboard>
      )}
    </>
  )
}
